import { render, staticRenderFns } from "./ChannelChart.vue?vue&type=template&id=2580eb83&scoped=true"
import script from "./ChannelChart.vue?vue&type=script&lang=js"
export * from "./ChannelChart.vue?vue&type=script&lang=js"
import style0 from "./ChannelChart.vue?vue&type=style&index=0&id=2580eb83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580eb83",
  null
  
)

export default component.exports